import { Colors } from "@blueprintjs/core";
import styled from "@emotion/styled";
import Select from "react-select";

import { Box } from "@/components/layout/flexbox";

const SelectBox = styled(Box)`
  min-width: 120px;
  border-radius: 6px;
  border: none;
  color: ${Colors.BLACK};
  margin-top: 10px;

  .select-time-range {
    [class$="-control"] {
      border: none;
      border-radius: 6px;
      background-color: ${Colors.LIGHT_GRAY5};
      padding: 4px 4px;
    }

    &.select-time-range-mini {
      [class$="-control"] {
        padding: 4px;
      }
    }
  }
`;

export default function SpecialtiesSelector({
  value,
  onChange,
  loading = false,
  disabled = false,
  options = [],
  className = "select-time-range",
}) {
  return (
    <SelectBox>
      <Select
        isDisabled={disabled}
        className={className}
        isLoading={loading}
        value={options.find((option) => option.value == value)}
        onChange={onChange}
        isSearchable={true}
        name="timeZone"
        options={options}
      />
    </SelectBox>
  );
}
